// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-fc81b020] {\n  background-color: #fff;\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n}\n.url[data-v-fc81b020] {\n  height: 100%;\n}\n.url p[data-v-fc81b020] {\n    display: inline-block;\n    margin: 0 10px;\n}\n.url p[data-v-fc81b020]:hover {\n    cursor: pointer;\n}\n.url a[data-v-fc81b020] {\n    color: #000;\n    text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
